// reducers/employee-onboarding/remove.js

// remove

export function removeHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_REMOVE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function removeIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_REMOVE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function remove(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_REMOVE_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

// removeDisplay

export function removeDisplayHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_REMOVE_DISPLAY_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function removeDisplayIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_REMOVE_DISPLAY_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function removeDisplay(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_REMOVE_DISPLAY_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}